import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'components/Luxkit/Typography/Caption'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextLink from 'components/Luxkit/TextLink'
import { CalendarPickerMonthView } from 'selectors/offerPage/offerPageSelectors'
import { pluralizeToString } from 'lib/string/pluralize'
import { useAppSelector } from 'hooks/reduxHooks'
import { OptimizelyExperiments, getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'

interface Props {
  duration: number;
  month: CalendarPickerMonthView;
  hasOtherAvailability: boolean;
  enableCalendarRecommendations: boolean;
  selected?: boolean;
  soldOutText?: string;
  displayMemberPrice: boolean;
}

function OfferCalendarHotelMonthTile(props: Props) {
  const {
    month,
    duration,
    hasOtherAvailability,
    enableCalendarRecommendations,
    selected,
    soldOutText = 'SOLD OUT',
    displayMemberPrice,
  } = props

  const subTextColour = selected ? undefined : 'neutral-three'
  const isPerNightPricingTestEnabled = !!useAppSelector((state: App.State) => getOptimizelyExperimentVariation(state, OptimizelyExperiments.pricePerNight))
  const hotelTotal = isPerNightPricingTestEnabled ? Math.ceil(month.hotelTotal / duration) : month.hotelTotal
  const saleUnit = isPerNightPricingTestEnabled ? '/night' : 'total'

  return (
    <div>
      {!month.hotelAvailable && <>
        <Caption variant="large" colour={subTextColour}>{soldOutText}</Caption>
        {!hasOtherAvailability && enableCalendarRecommendations && <TextLink size="small" weight="regular">
          See more great offers
        </TextLink>}
        {hasOtherAvailability &&
          <TextLink size="small" weight="regular">
            Available in other room types
          </TextLink>
        }
      </>}
      {month.hotelAvailable && <div>
        <Caption variant="large" colour={subTextColour}>{pluralizeToString('night', duration)} from</Caption>
        <BodyText as="span" variant="large" weight="bold" colour={(displayMemberPrice && !selected) ? 'loyalty' : undefined}>
          <FormatCurrency value={hotelTotal} />
        </BodyText>{' '}
        <Caption as="span" variant="large" colour={(displayMemberPrice && !selected) ? 'loyalty' : subTextColour}>{saleUnit}</Caption>
      </div>}
    </div>
  )
}

export default React.memo(OfferCalendarHotelMonthTile)
